export const PRODUCT_CATEGORY_CONFIG = {
  CATEGORY_LIST: {
    endPoint: 'dropdowns/categories', // New API returns { id, en }; map id→categoryId, en→category
    version: 'v1',
    method: 'GET',
    baseUrlKey: 'inventoryApiUrl',
  },
}
  